



























import Vue from 'vue'
import Component from 'vue-class-component'
import {Action} from 'vuex-class';
import Pagination, {PaginationInput} from '@/modules/core/model/pagination';
import User from '@/modules/user/model/User';
import {Prop} from 'vue-property-decorator';
import {FindUserCriteria} from '@/modules/user/api';

const findUserCriteria = (): FindUserCriteria => ({
    excludeGroups: [],
    includeGroups: [],
    searchBy: {
        field: 'all',
        value: '',
    },
})

/**
 * Pequeño complemente que permite mostrar una lista resumida
 * de usuarios
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class UserListWidget extends Vue {
    /**
     * Criterios de filtrado de usuarios
     *
     * @var { FindUserCriteria }
     */
    @Prop({type: Object, default: findUserCriteria()})
    public criteria: FindUserCriteria

    /**
     * Título mostrado en la barra superior del componente
     *
     * @var { string }
     */
    @Prop({type: String, default: 'Usuarios'})
    public title: string
    /**
     * Carga una paginación de usuarios en el estado de la aplicación.
     */
    @Action('user/loadPagination')
    public loadPagination: (input: PaginationInput) => Promise<Pagination<User>>

    public loading = true
    public search = ''

    public get pagination (): Pagination<User> {
        return this.$store.state.user.namedUserPaginations[this.paginationName] || {}
    }

    public get paginationName () {
        return `pagination-groups-${this.criteria.includeGroups?.join('_')}`
    }

    public async mounted () {
        await this.loadPagination({
            name: this.paginationName,
            page: 1,
            recordsPerPage: 300,
            filters: this.criteria,
        })

        this.loading = false
    }
}
